import React from 'react';

//Component
import { Button } from '@mui/material';

//Hook & Constants
import { useAxios } from '../../hooks/use-axios';
import { evenTypeUrl } from '../../constants/';

//Css
import styled from 'styled-components';

const Root = styled.div``;
const Row = styled.div`
  display: flex;
  flex: wrap;
`;
const Title = styled.label`
  font-size: 16px;
  font-weigth: 600;
`;
const Information = styled.p`
  font-size: 14px;
`;

export const DeleteEventType = props => {
  const { obj, handleClose } = props;
  const element = JSON.parse(obj);
  const { put } = useAxios();

  const handleClick = event => {
    event.preventDefault();
    element.status = false;

    const res = put(evenTypeUrl.UPDATE_EVENT_TYPE, element);
    if (res) handleClose();
  };

  return (
    <Root>
      <Row>
        <Title>Nombre</Title>
        <Information>{element.name}</Information>
      </Row>
      <Row>
        <Title>Estado</Title>
        <Information>{element.status}</Information>
      </Row>
      <Row>
        <Button type='submit' onClick={handleClick}>
          Deshabilitar
        </Button>
      </Row>
    </Root>
  );
};
